module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre19",
    attrs: {
      "id": "pgepubid00024"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre22",
    attrs: {
      "summary": "CONTENTS"
    }
  }, [_c('tbody', {
    staticClass: "calibre10"
  }, [_c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smaller"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("v")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "smaller"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("I.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Deportation To Russia")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("II.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Petrograd")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("III.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Disturbing Thoughts")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("IV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Moscow: First Impressions")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("V.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Meeting People")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("VI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Preparing for American Deportees")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("VII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rest Homes for Workers")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("VIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The First of May in Petrograd")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("IX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Industrial Militarization")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("X.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The British Labour Mission")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Visit from the Ukraina")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Beneath the Surface")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Joining the Museum of the Revolution")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XIV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Petropavlovsk and Schlüsselburg")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00025",
      "title": "[Pg xxii]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_xxii",
      "title": "[Pg xxii]"
    }
  })]), _vm._v("XV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Trade Unions")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XVI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Maria Spiridonova")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XVII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Another Visit to Peter Kropotkin")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XVIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("En Route")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XIX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In Kharkov")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Poltava")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("XXI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Kiev")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre23",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0